import { jsx } from 'panel';
import { RowSelector } from 'common/widgets/query-entry-section/components/selector';
import { BaseEntryRowEl } from '../base/template';
export function SegmentEntryRowEl(_ref) {
  let {
    section,
    entry,
    index
  } = _ref;

  const selectorRenderer = () => jsx(RowSelector, {
    el: section,
    entry: entry,
    index: index,
    isPlaceholder: !this.hasEventValue()
  });

  return jsx(BaseEntryRowEl, {
    index: index,
    el: section,
    entry: entry,
    rowRenderer: {
      prefixRenderer: null,
      selectorRenderer,
      suffixRenderer: null
    },
    isPlaceholder: this.isPlaceholder()
  });
}